(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("platformsh-client"));
	else if(typeof define === 'function' && define.amd)
		define("userWidget", ["platformsh-client"], factory);
	else if(typeof exports === 'object')
		exports["userWidget"] = factory(require("platformsh-client"));
	else
		root["userWidget"] = factory(root["platformsh-client"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_140__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition